
import create from '../utils/create';

export default create({
  render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('span', { staticClass: "van-hairline--surround", class: _vm.b((_obj = {
        mark: _vm.mark,
        plain: _vm.plain
      }, _obj[_vm.type] = _vm.type, _obj)) }, [_vm._t("default")], 2);
    var _obj;
  },

  name: 'tag',
  props: {
    type: String,
    mark: Boolean,
    plain: Boolean
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/tag/index.js
// module id = 260
// module chunks = 80